var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._g(_vm._b({attrs:{"disabled":_vm.disabled,"rules":_vm.required && !_vm.disabled ? [_vm.validate] : [],"item-text":_vm.itemText,"item-value":_vm.itemValue}},'v-select',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }